
import { supabase } from "@/integrations/supabase/client";
import { Channel } from "@/lib/types";
import { toast } from "sonner";

export const createChannel = async (
  groupId: string,
  channelData: {
    name: string;
    description?: string;
    isAnnouncement?: boolean;
    isTemporary?: boolean;
    autoDeleteAfter?: number;
  },
  userId: string
): Promise<boolean> => {
  try {
    const { error } = await supabase
      .from("channels")
      .insert({
        group_id: groupId,
        name: channelData.name,
        description: channelData.description,
        is_announcement: channelData.isAnnouncement || false,
        is_temporary: channelData.isTemporary || false,
        auto_delete_after: channelData.autoDeleteAfter,
        created_by: userId,
      });

    if (error) {
      console.error("Error creating channel:", error);
      toast.error("Failed to create channel");
      return false;
    }

    toast.success("Channel created successfully");
    return true;
  } catch (error) {
    console.error("Error creating channel:", error);
    toast.error("Failed to create channel");
    return false;
  }
};

export const updateChannel = async (
  channelId: string,
  updates: Partial<Channel>
): Promise<boolean> => {
  try {
    const { error } = await supabase
      .from("channels")
      .update({
        name: updates.name,
        description: updates.description,
        is_announcement: updates.isAnnouncement,
        is_temporary: updates.isTemporary,
        auto_delete_after: updates.autoDeleteAfter,
      })
      .eq("id", channelId);

    if (error) {
      console.error("Error updating channel:", error);
      toast.error("Failed to update channel");
      return false;
    }

    toast.success("Channel updated successfully");
    return true;
  } catch (error) {
    console.error("Error updating channel:", error);
    toast.error("Failed to update channel");
    return false;
  }
};

export const deleteChannel = async (channelId: string): Promise<boolean> => {
  try {
    const { error } = await supabase
      .from("channels")
      .delete()
      .eq("id", channelId);

    if (error) {
      console.error("Error deleting channel:", error);
      toast.error("Failed to delete channel");
      return false;
    }

    toast.success("Channel deleted successfully");
    return true;
  } catch (error) {
    console.error("Error deleting channel:", error);
    toast.error("Failed to delete channel");
    return false;
  }
};
